/* 按照比例缩放界面
 * 参数配置：
 * [designWidth: 设计图尺寸]
 * [rem2px: 缩放比例,如 1rem = 100px, 此处填100]
 * [defaultFontSize: 默认字体大小 px,浏览器默认为16px]
 * */
const adoptdevice = function (designWidth, rem2px, defaultFontSize) {
  var head = window.document.getElementsByTagName('head')[0]
  // 根据html的宽度来设置rem
  var currentWindowWidth = window.getComputedStyle(document.getElementsByTagName('html')[0])['width'].slice(0, -2)
  document.documentElement.style.fontSize = currentWindowWidth / designWidth * rem2px / defaultFontSize * 100 + '%'
  var x = currentWindowWidth / designWidth * rem2px / defaultFontSize * 100 + '%'
  var st = document.createElement('style')
  var portrait = '@media screen and (min-width: ' + currentWindowWidth + 'px) {html{font-size:' + x + ' }}'
  /*
 var landscape = "@media screen and (min-width: "+window.innerHeight+"px) {html{font-size:"+ ((window.innerHeight/(designWidth/rem2px)/defaultFontSize)*100) +"%;}}"
  */
  st.innerHTML = portrait
  head.appendChild(st)
}

/**
 * 日期格式化
 */
const formatDate = (mydate, pattern) => {
  var date = new Date(mydate)
  function format (m) {
    var n = m + 1
    if (n < 10) {
      return `0${n}`
    }
    return n
  }
  var year = date.getFullYear()
  var month = format(date.getMonth())
  var day = format(date.getDate() - 1)
  var hour = format(date.getHours() - 1)
  var minute = format(date.getMinutes() - 1)
  var second = format(date.getSeconds() - 1)
  switch (pattern) {
    case 'yyyy':
      return year
      break
    case 'yyyy-MM-dd':
      return `${year}-${month}-${day}`
      break
    case 'yyyy.MM.dd':
      return `${year}.${month}.${day}`
      break
    case 'yyyy-MM-dd HH':
      return `${year}-${month}-${day} ${hour}`
      break
    case 'yyyy-MM-dd HH:mm':
      return `${year}-${month}-${day} ${hour}:${minute}`
      break
    case 'yyyy-MM-dd HH:mm:ss':
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
      break
    case 'yyyy/MM':
      return `${year}/${month}`
      break
    case 'MM月dd日':
      return `${month}月${day}日`
      break
    case 'HH:mm':
      return `${hour}:${minute}`
      break
    default :
      return 0
  }
}

/**
 *存储localStorage
 */
const setStore = (name, content) => {
  if (!name) return
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
const getStore = (name) => {
  if (!name) return
  return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
const removeStore = (name) => {
  if (!name) return
  window.localStorage.removeItem(name)
}

/**
 * 读取cookie
 */
const getCookie = (cName) => {
  if (document.cookie.length > 0) {
    let cStart = document.cookie.indexOf(`${cName}=`)
    if (cStart !== -1) {
      cStart = cStart + cName.length + 1
      let cEnd = document.cookie.indexOf(';', cStart)
      if (cEnd === -1) cEnd = document.cookie.length
      return document.cookie.substring(cStart, cEnd)
    }
  }
  return ''
}

/**
 * 存储setcookie
 */
const setCookie = (name, info) => {
  /* 设置cookie时长/天 */
  // const validity = 1
  // const now = new Date()
  // now.setTime(now.getTime() + validity * 24 * 60 * 60 * 1000)
  // document.cookie = `${name}=${info};expires=${now.toGMTString()}`
  document.cookie = `${name}=${info};}`
}

/**
 * 删除cookie
 */
const delCookie = (name) => {
  /* 设置cookie时长/天 */
  const validity = 1
  var exp = new Date()
  exp.setTime(exp.getTime() - validity * 24 * 60 * 60 * 1000)
  var cval = getCookie(name)
  if (cval != null) {
    document.cookie = `${name}=${cval};expires=${exp.toGMTString()}`
  }
}

/**
 *解析URL参数
 * */
const parseQuery = (query) => {
  if (query.indexOf('?') !== -1) {
    const searchList = query.split('?')
    let arr = []
    arr = searchList[1].split('&')
    /* 声明变量为对象，加{} */
    const result = {}
    for (let i = arr.length - 1; i >= 0; i--) {
      const arr2 = arr[i].split('=')
      result[arr2[0]] = arr2[1]
    }
    return result
  } else {
    return 0
  }
}

module.exports = {
  adoptdevice,
  formatDate,
  setStore,
  getStore,
  removeStore,
  getCookie,
  setCookie,
  delCookie,
  parseQuery
}



// WEBPACK FOOTER //
// ./src/libs/utils.js